export const layoutsMisc = {
  confirm: {
    defaultTitle: "Czy na pewno?",
    confirm: "Potwierdź",
    cancel: "Anuluj",
  },
  navPluginWeb: {
    title: "Utwórz stronę internetową",
    stepOf: "{step} z 5",
  },
  saMenu: {
    title: "Akcje systemowe",
    subtitle: "Panel automatyzacji",
    sectionComms: "KOMUNIKACJA",
    firstCheckin: "Wyślij przy pierwszym check-in",
  },
  systemActions: {
    checkin: "Check-in",
  },
  regionMessage: {
    text: "Prosimy o kontakt z zespołem pomocy technicznej w celu skonfigurowania połączenia.",
    contactSupport: "Skontaktuj się z pomocą",
  },
  selectionScanner: {
    title: "Wybierz typ dokumentu do zeskanowania",
    idCard: "Dowód osobisty",
    passport: "Paszport",
  },
};
